<template>
  <div v-if="pageInfo" id="page-info">
    <div class="select-page">
      <span class="page-now pointer" :class="{'not-allowed':clickLastPage}" @click="firstPage">首页</span>
      <span class="page-now pointer" :class="{'not-allowed':clickLastPage}" @click="previousPage">上一页</span>
      <span class="page-now pointer" :class="{'not-allowed':clickFirstPage}" @click="nextPage">下一页</span>
      <span class="page-now pointer" :class="{'not-allowed':clickFirstPage}" @click="lastPage">尾页</span>
      <input v-model="pageInfo.index" class="page-now" style="margin-left:6px;" @blur="searchFirst">/
      <span class="page-count" style="color:#f00;">{{ pageInfo.pages }}</span>页
    </div>
    <div class="page-des">
      每页显示
      <input v-model="pageInfo.size" class="page-now data-now" @blur="searchFirst">条，
      共
      <span class="data-count" style="color:#f00;">{{ pageInfo.count }}</span>条数据
      <span class="fresh pointer" style="color:blue;" @click="searchFirst">刷新</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pageInfo: {
      type: Object,
      default: null
    }
  },
  data () {
    return {

    }
  },
  computed: {
    clickLastPage: function () {
      let click = true
      if (this.pageInfo.index !== 1) {
        click = false
      }
      return click
    },
    clickFirstPage: function () {
      let click = false
      if (this.pageInfo.index === this.pageInfo.pages) {
        click = true
      }
      return click
    }
  },
  methods: {
    searchFirst () {
      document.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.$emit('searchFirst', this.pageInfo)
    },
    firstPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index = 1
        this.searchFirst()
      }
    },
    previousPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index -= 1
        this.searchFirst()
      }
    },
    nextPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index = Number(this.pageInfo.index) + 1
        this.searchFirst()
      }
    },
    lastPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index = this.pageInfo.pages
        this.searchFirst()
      }
    }
  }
}
</script>
<style>
  #page-info {
    height: 30px;
    display:flex;
    padding-top: 5px;
    background-color: #e3e4e5;
    font-size: 0.75rem;
  }
  #page-info .pointer {
    cursor: pointer;
  }
  #page-info .not-allowed {
    cursor: not-allowed;
  }
  #page-info .select-page {
    width: 31%;
    height: 100%;
    border-right: 1px solid #000;
    text-align: left;
    padding: 0 20px;
  }
  #page-info .page-des {
    width: 69%;
    text-align: left;
    padding-left: 20px;
  }
  #page-info .page-now{
    width: 43px;
    height: 20px;
    border-radius: 4px;
    display: inline-block;
    border: 1px solid #ccc;
    background: #fff;
    text-align: center;
    margin-right: 3px;
  }
</style>
